// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

import classNames from 'classnames';
import SkeletonText from './SkeletonText';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Skeleton for tabs component
 * @since `3.28.0
 */
const SkeletonTabs = _ref => {
  let {
    count = 3,
    className,
    baseClassName = `${CLS_PREFIX}skeleton-tabs`,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(baseClassName, className),
    ...props,
    children: /*#__PURE__*/_jsx(SkeletonText, {
      lineProps: {
        maxWidth: 100
      },
      lines: count
    })
  });
};
export default SkeletonTabs;